module.exports = __webpack_public_path__ + "static/media/arrow-up.2dfa76b7.svg";